import React from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { X, Bell, CheckCircle2, User, MessageSquare, AlertTriangle, Calendar, Trash2, DollarSign, RotateCcw, AlertCircle, PlusCircle, Zap, Clock, Check, Pencil, ImageIcon, Search, Phone, Pin } from 'lucide-react';
import { CantinaProductSection } from './CantinaProductSection';

export interface AdminBookingDetailModalProps {
  selectedSlot: any;
  setSelectedSlot: any;
  setSelectedPlayer: any;
  setSearchPlayerQuery: any;
  manualPlayerName: any;
  setFormResetKey: any;
  setShowPlayerDropdown: any;
  setIsEditingPrice: any;
  setShowCancelConfirmPopup: any;
  activeBooking: any;
  getShortDayOfWeek: any;
  isNextImmediatePendingTurn: any;
  schedule: any;
  handleSendConfirmationRequest: any;
  setShowConfirmAttendancePopup: any;
  showConfirmAttendancePopup: any;
  handleConfirmFixedBooking: any;
  onOpenChatWithPlayer: any;
  players: any;
  handleUpdateBookingNotes: any;
  showCobradoToast: any;
  showCancelConfirmPopup: any;
  executeDeleteBooking: any;
  setChargePaymentTotal: any;
  currentSlotBookingTotal: any;
  setChargePaymentCash: any;
  setChargePaymentTransfer: any;
  setShowChargeConfirmModal: any;
  handleUnmarkPaid: any;
  showItemDropdown: any;
  setShowItemDropdown: any;
  availableProducts: any;
  handleDirectAddToCart: any;
  handleRemoveFromTicket: any;
  setShowQuickItemModal: any;
  showQuickItemModal: any;
  quickItemName: any;
  setQuickItemName: any;
  quickItemPrice: any;
  setQuickItemPrice: any;
  setQuickItemQuantity: any;
  quickItemQuantity: any;
  handleAddQuickItem: any;
  isEditingDiscount: any;
  tempDiscount: any;
  handleSaveDiscountPercent: any;
  setIsEditingDiscount: any;
  setTempDiscount: any;
  currentDiscountPercent: any;
  handleUpdateCourtPaidPlayers: any;
  tempCourtSelect: any;
  isEditingPrice: any;
  tempPrice: any;
  handleUpdateBookingPrice: any;
  setTempPrice: any;
  bookingItems: any;
  ensureMaterialized: any;
  handleUpdateItemQuantity: any;
  handleUpdateItemPaidCount: any;
  tempItemSelect: any;
  handleRemoveProductFromSlot: any;
  currentSlotPaidTotal: any;
  currentSlotRemainingTotal: any;
  setModalActiveTab: any;
  modalActiveTab: any;
  selectedPlayer: any;
  searchPlayerQuery: any;
  filteredPlayers: any;
  showPlayerDropdown: any;
  formResetKey: any;
  manualPlayerPhone: any;
  setManualIsFixed: any;
  manualIsFixed: any;
  manualNotes: any;
  handleAssignBooking: any;
  promoDiscount: any;
  setPromoDiscount: any;
  promoDrink: any;
  setPromoDrink: any;
  promoBalls: any;
  setPromoBalls: any;
  promoWinnerPrize: any;
  setPromoWinnerPrize: any;
  handleDeletePromo: any;
  handleSavePromo: any;
}

export const AdminBookingDetailModal: React.FC<AdminBookingDetailModalProps> = (props) => {
  const {
    selectedSlot,
    setSelectedSlot,
    setSelectedPlayer,
    setSearchPlayerQuery,
    manualPlayerName,
    setFormResetKey,
    setShowPlayerDropdown,
    setIsEditingPrice,
    setShowCancelConfirmPopup,
    activeBooking,
    getShortDayOfWeek,
    isNextImmediatePendingTurn,
    schedule,
    handleSendConfirmationRequest,
    setShowConfirmAttendancePopup,
    showConfirmAttendancePopup,
    handleConfirmFixedBooking,
    onOpenChatWithPlayer,
    players,
    handleUpdateBookingNotes,
    showCobradoToast,
    showCancelConfirmPopup,
    executeDeleteBooking,
    setChargePaymentTotal,
    currentSlotBookingTotal,
    setChargePaymentCash,
    setChargePaymentTransfer,
    setShowChargeConfirmModal,
    handleUnmarkPaid,
    showItemDropdown,
    setShowItemDropdown,
    availableProducts,
    handleDirectAddToCart,
    handleRemoveFromTicket,
    setShowQuickItemModal,
    showQuickItemModal,
    quickItemName,
    setQuickItemName,
    quickItemPrice,
    setQuickItemPrice,
    setQuickItemQuantity,
    quickItemQuantity,
    handleAddQuickItem,
    isEditingDiscount,
    tempDiscount,
    handleSaveDiscountPercent,
    setIsEditingDiscount,
    setTempDiscount,
    currentDiscountPercent,
    handleUpdateCourtPaidPlayers,
    tempCourtSelect,
    isEditingPrice,
    tempPrice,
    handleUpdateBookingPrice,
    setTempPrice,
    bookingItems,
    ensureMaterialized,
    handleUpdateItemQuantity,
    handleUpdateItemPaidCount,
    tempItemSelect,
    handleRemoveProductFromSlot,
    currentSlotPaidTotal,
    currentSlotRemainingTotal,
    setModalActiveTab,
    modalActiveTab,
    selectedPlayer,
    searchPlayerQuery,
    filteredPlayers,
    showPlayerDropdown,
    formResetKey,
    manualPlayerPhone,
    setManualIsFixed,
    manualIsFixed,
    manualNotes,
    handleAssignBooking,
    promoDiscount,
    setPromoDiscount,
    promoDrink,
    setPromoDrink,
    promoBalls,
    setPromoBalls,
    promoWinnerPrize,
    setPromoWinnerPrize,
    handleDeletePromo,
    handleSavePromo
  } = props;

  const [cooldown, setCooldown] = React.useState(0);

  React.useEffect(() => {
    if (!activeBooking?.confirmationRequestedAt) {
      setCooldown(0);
      return;
    }
    
    const checkCooldown = () => {
      const diff = Date.now() - activeBooking.confirmationRequestedAt;
      const remaining = 600000 - diff; // 10 minutes in ms
      if (remaining > 0) {
        setCooldown(remaining);
      } else {
        setCooldown(0);
      }
    };
    
    checkCooldown();
    const interval = setInterval(checkCooldown, 1000);
    return () => clearInterval(interval);
  }, [activeBooking?.confirmationRequestedAt]);

  return (
    <>
      {/* 4. MODAL / BOTTOM SHEET DE ACCIONES (ELEGANT BOTTOM SHEET/MODAL) */}
      {selectedSlot && typeof document !== 'undefined' && createPortal(
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm p-4 animate-in fade-in duration-300"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              setSelectedSlot(null);
              setSelectedPlayer(null);
              setSearchPlayerQuery('');
              manualPlayerName.current = '';
              setFormResetKey(k => k + 1);
              setShowPlayerDropdown(false);
              setIsEditingPrice(false);
              setShowCancelConfirmPopup(false);
            }
          }}
        >
          <div
            className={`flex flex-col max-h-[98vh] sm:max-h-[96vh] w-full bg-[#1a1c23] border border-[#2d313f] rounded-2xl overflow-hidden shadow-2xl relative animate-in zoom-in-95 duration-300 ${activeBooking && activeBooking.status !== 'promo' ? 'max-w-md md:max-w-4xl lg:max-w-[1000px]' : 'max-w-md'}`}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >

            {/* Header del modal */}
            <div className="shrink-0 py-2.5 px-4 bg-[#222530] border-b border-[#2d313f] relative flex flex-col items-center justify-center min-h-[50px]">
              {activeBooking && activeBooking.status !== 'promo' ? (
                <>
                  {(() => {
                    const isCancelled = activeBooking.status === 'cancelled' || (activeBooking.hiddenFromGrid && activeBooking.courtId !== 'pos_cantina' && activeBooking.courtId !== 'expense');
                    const isPaid = !isCancelled && activeBooking.status === 'paid';
                    const isPending = !isCancelled && (activeBooking.status === 'pending' || activeBooking.confirmationStatus === 'pending_confirmation') && !activeBooking.playerConfirmed;
                    const isConfirmed = !isCancelled && ((activeBooking.status === 'confirmed' && activeBooking.confirmationStatus !== 'pending_confirmation') || activeBooking.playerConfirmed);

                    let badgeBg = 'bg-sky-500/20 text-sky-400 border-sky-500/30';
                    let badgeText = 'Confirmado';
                    if (isCancelled) {
                      badgeBg = 'bg-red-500/20 text-red-400 border-red-500/30';
                      badgeText = 'Cancelado';
                    } else if (isPaid) {
                      if (activeBooking.courtId === 'expense') {
                        badgeBg = 'bg-red-500/20 text-red-400 border-red-500/30';
                        badgeText = 'Egreso';
                      } else {
                        badgeBg = 'bg-green-500/20 text-green-400 border-green-500/30';
                        badgeText = 'Cobrado';
                      }
                    } else if (isPending) {
                      badgeBg = 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
                      badgeText = 'Pendiente';
                    }
                    return (
                      <div className="flex gap-2 mb-2 sm:absolute sm:left-3 sm:top-3 sm:mb-0 w-full sm:w-auto justify-center sm:justify-start">
                        <span className={`inline-block text-[9px] border px-2 py-0.5 rounded font-black uppercase tracking-wider ${badgeBg}`}>
                            {badgeText}
                          </span>
                          {(activeBooking.promoDiscountPercentage > 0 || activeBooking.promoDetails?.discount > 0 || activeBooking.promoPerks?.drink || activeBooking.promoDetails?.drink || activeBooking.promoPerks?.balls || activeBooking.promoDetails?.balls || activeBooking.promoPerks?.winnerPrize || activeBooking.promoDetails?.winnerPrize) && (
                            <div className="flex items-center gap-1">
                              {(activeBooking.promoDiscountPercentage > 0 || activeBooking.promoDetails?.discount > 0) && (
                                <span className="inline-block text-[9px] border px-2 py-0.5 rounded font-black uppercase tracking-wider bg-purple-500/20 text-purple-400 border-purple-500/30 flex items-center gap-1">
                                  PROMO {activeBooking.promoDiscountPercentage || activeBooking.promoDetails?.discount}%
                                </span>
                              )}
                              {(activeBooking.promoPerks?.drink || activeBooking.promoDetails?.drink || activeBooking.promoPerks?.balls || activeBooking.promoDetails?.balls || activeBooking.promoPerks?.winnerPrize || activeBooking.promoDetails?.winnerPrize) && (
                                <div className="flex items-center gap-1">
                                  {(activeBooking.promoPerks?.drink || activeBooking.promoDetails?.drink) && <span className="text-[10px]" title="Bebida de cortesía">🥤</span>}
                                  {(activeBooking.promoPerks?.balls || activeBooking.promoDetails?.balls) && <span className="text-[10px] flex items-center justify-center drop-shadow-md" title="Pelotas nuevas"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#ccff00" stroke="#9acd00" strokeWidth="1"/><path d="M6 5.3a9 9 0 0 1 0 13.4" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"/><path d="M18 5.3a9 9 0 0 0 0 13.4" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"/></svg></span>}
                                  {(activeBooking.promoPerks?.winnerPrize || activeBooking.promoDetails?.winnerPrize) && <span className="text-[10px]" title="Premio al ganador">🏆</span>}
                                </div>
                              )}
                            </div>
                          )}
                        {(activeBooking.paymentStatus === 'partial_paid' || activeBooking.paymentStatus === 'full_paid') && (
                          <span className="inline-block text-[9px] border px-2 py-0.5 rounded font-black uppercase tracking-wider bg-emerald-500/20 text-emerald-400 border-emerald-500/30">
                            SEÑA {activeBooking.courtPaidPlayersCount ? `${Math.round((activeBooking.courtPaidPlayersCount / 4) * 100)}%` : '25%'} PAGADA
                          </span>
                        )}
                      </div>
                    );
                  })()}
                  <div className="text-center">
                    <h3 className="text-sm font-black uppercase tracking-widest text-white">
                      {activeBooking?.courtId === 'pos_cantina' ? 'Detalle de Venta' : activeBooking?.courtId === 'expense' ? 'Detalle de Egreso' : 'Detalle de Reserva'}
                    </h3>
                    <div className="text-[11px] text-theme-primary font-black uppercase mt-1 flex items-center justify-center gap-1.5 flex-wrap">
                      <span>{getShortDayOfWeek(activeBooking.date)}</span>
                      <span className="text-zinc-500">•</span>
                      <span>{activeBooking.date.split('-').reverse().join('/')}</span>
                      <span className="text-zinc-500">•</span>
                      <span>{activeBooking.courtName}</span>
                      <span className="text-zinc-500">•</span>
                      <span>{activeBooking.timeSlot}h</span>
                    </div>
                  </div>
                </>
              ) : (
                <div className="w-full text-center px-8">
                  <h3 className="text-sm font-black uppercase tracking-wider text-white">
                    {selectedSlot.booking?.status === 'promo' ? 'Editar Promoción' : 'Gestionar Turno Vacío'}
                  </h3>
                  <p className="text-[10px] text-theme-primary font-black uppercase mt-0.5">
                    {selectedSlot.court} — {selectedSlot.time}h
                  </p>
                </div>
              )}

              <button
                onClick={() => {
                  setSelectedSlot(null);
                  setSelectedPlayer(null);
                  setSearchPlayerQuery('');
                  manualPlayerName.current = '';
                  setFormResetKey(k => k + 1);
                  setShowPlayerDropdown(false);
                  setIsEditingPrice(false);
                  setShowCancelConfirmPopup(false);
                }}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-white p-1.5 rounded-lg hover:bg-white/10 hover:scale-110 active:scale-90 transition-all duration-200 cursor-pointer"
              >
                <X size={18} />
              </button>
            </div>

            {/* CONTENIDO: CASO TURNO EXISTENTE (MOSTRAR DETALLES + ACCIONES EN DOS COLUMNAS EN DESKTOP) */}
            {activeBooking && activeBooking.status !== 'promo' ? (
              <div className="flex-1 min-h-0 overflow-y-auto md:overflow-hidden p-5 grid grid-cols-1 md:grid-cols-5 gap-6">

                {/* COLUMNA IZQUIERDA: JUGADOR, NOTAS Y ACCIONES */}
                <div className="md:col-span-2 flex flex-col justify-between space-y-6 min-h-0 overflow-y-auto custom-scrollbar pr-1 pb-1">
                  <div className="space-y-5">
                    {/* SECCIÓN DE ASISTENCIA (Solo para Turnos Fijos Pendientes) */}
                    {activeBooking.isFixed && isNextImmediatePendingTurn && !activeBooking.playerConfirmed && activeBooking.status !== 'paid' && activeBooking.status !== 'confirmed' && (
                      <div className="bg-[#15171d] p-4 rounded-xl border border-amber-500/20 space-y-4 text-center shadow-lg">
                        {/* 1. Info Recordatorio Automático (Opcional) & 2. Botón Consultar Asistencia */}
                        {activeBooking.playerId && players?.some((p: any) => p.id === activeBooking.playerId && !(p.isGuest || p.id.startsWith('guest_') || p.id.length !== 28)) && (
                          <>
                            <div className="flex justify-center pt-1">
                              <button
                                onClick={() => handleSendConfirmationRequest(activeBooking!)}
                                disabled={cooldown > 0}
                                className={`w-full ${cooldown <= 0 ? 'hover:scale-[1.02] active:scale-[0.98] cursor-pointer' : 'cursor-not-allowed opacity-80'} border py-2.5 rounded-xl text-[10px] font-black uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-2 ${activeBooking.confirmationRequested
                                  ? 'bg-zinc-800/80 text-zinc-400 border-zinc-700 hover:bg-zinc-700/50'
                                  : 'bg-[#25D366]/10 text-[#25D366] border-[#25D366]/20 hover:bg-[#25D366]/20 hover:border-[#25D366]/30'
                                  }`}
                              >
                                <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
                                </svg>
                                {cooldown > 0 
                                  ? `Re-enviar Consulta en ${Math.floor(cooldown / 60000).toString().padStart(2, '0')}:${Math.floor((cooldown % 60000) / 1000).toString().padStart(2, '0')}`
                                  : activeBooking.confirmationRequested 
                                    ? 'Re-enviar Consulta' 
                                    : 'Consultar Asistencia'}
                              </button>
                            </div>
                          </>
                        )}

                        {/* 3. Botón Confirmar Asistencia Manualmente (Amarillo) */}
                        <div className="flex justify-center pt-1">
                          <button
                            onClick={() => setShowConfirmAttendancePopup(true)}
                            className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-black uppercase text-[10px] py-2.5 rounded-xl transition-all shadow-lg hover:shadow-yellow-400/30 hover:scale-[1.02] active:scale-[0.98] cursor-pointer flex items-center justify-center gap-2 group"
                          >
                            <CheckCircle2 size={14} className="group-hover:rotate-12 transition-transform" />
                            Confirmar Asistencia Manualmente
                          </button>
                        </div>

                        {showConfirmAttendancePopup && (
                          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in">
                            <div className="bg-[#15171d] border border-[#2d313f] rounded-2xl p-6 max-w-sm w-full space-y-4 shadow-xl">
                              <h4 className="text-sm font-black text-white uppercase tracking-wider text-center">¿Confirmar Asistencia?</h4>
                              <p className="text-xs text-zinc-300 text-center leading-relaxed">
                                Estás por confirmar manualmente la asistencia del jugador <b>{activeBooking.playerName}</b> para este turno.
                              </p>
                              <div className="flex gap-3 pt-2">
                                <button
                                  onClick={() => setShowConfirmAttendancePopup(false)}
                                  className="flex-1 py-2 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 font-bold text-xs uppercase rounded-xl transition-all cursor-pointer"
                                >
                                  Cancelar
                                </button>
                                <button
                                  onClick={() => handleConfirmFixedBooking(activeBooking)}
                                  className="flex-1 py-2 bg-yellow-400 hover:bg-yellow-500 text-black font-black text-xs uppercase rounded-xl transition-all shadow-md cursor-pointer"
                                >
                                  Confirmar
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* A nombre de: Centrado y sin fondo */}
                    {activeBooking.courtId !== 'expense' && (
                    <div className="flex items-center justify-between py-1 md:py-3 w-full">
                      {/* Left Side: Avatar and Name */}
                      <div className="flex items-center gap-2 md:gap-3">
                        <span className="text-zinc-400 font-bold uppercase text-[9px] md:text-[10px] tracking-wider shrink-0">Cliente:</span>

                        <div className="flex items-center gap-1.5 md:gap-2.5 min-w-0">
                          {activeBooking.playerPhoto ? (
                            <img src={activeBooking.playerPhoto} alt={activeBooking.playerName} className="w-7 h-7 md:w-9 md:h-9 rounded-full object-cover border border-theme-primary/40 shrink-0" />
                          ) : (
                            <div className="w-7 h-7 md:w-9 md:h-9 rounded-full bg-[#1e202b] flex items-center justify-center border border-[#2d313f] shrink-0">
                              <User size={14} className="text-zinc-400 md:w-4 md:h-4" />
                            </div>
                          )}
                          <div className="min-w-0 flex items-center">
                            <span className="text-xs md:text-base font-black text-white truncate">{activeBooking.playerName}</span>
                          </div>
                        </div>
                      </div>

                      {/* Right Side: Stacked Chat and WhatsApp */}
                      <div className="flex flex-col items-end gap-1.5">
                        {activeBooking.playerId && (
                          <button
                            onClick={() => {
                              onOpenChatWithPlayer?.(
                                activeBooking.playerId,
                                activeBooking.playerName || 'Jugador',
                                activeBooking.playerPhoto || ''
                              );
                            }}
                            className="bg-white hover:bg-yellow-400 text-black text-[10px] md:text-[11px] font-black uppercase px-4 py-1 md:px-5 md:py-1 rounded-full transition-all duration-200 cursor-pointer flex items-center gap-1.5 shrink-0 shadow-sm hover:scale-[1.03] active:scale-[0.97]"
                          >
                            <MessageSquare size={13} className="text-black" /> Chat
                          </button>
                        )}
                        {(() => {
                          const playerPhone = activeBooking.contactInfo || players.find(p => p.id === activeBooking.playerId)?.phone;
                          if (!playerPhone) return null;
                          return (
                            <a 
                              href={`https://wa.me/${playerPhone.replace(/\D/g, '')}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-[10px] md:text-xs text-white hover:text-green-400 truncate flex items-center gap-1.5 transition-all hover:scale-105 font-bold"
                              title="Escribir por WhatsApp"
                            >
                              <div className="text-green-500">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                              </div>
                              {playerPhone}
                            </a>
                          );
                        })()}
                      </div>
                    </div>
                    )}

                    {/* Notas de Reserva (Editable) */}
                    <div className="space-y-1">
                      <div className="flex items-center justify-between">
                        <span className="text-zinc-400 font-bold uppercase text-[9px] tracking-wider">Notas de Reserva</span>
                      </div>
                      <div className="relative mt-1">
                        <input
                          key={activeBooking.id}
                          type="text"
                          defaultValue={activeBooking.notes || ''}
                          placeholder={activeBooking.status === 'paid' ? 'No se pueden editar notas (Turno pagado)' : 'Escribe una nota y presiona Enter o haz click fuera para guardar...'}
                          className="w-full bg-[#15171d] text-white text-xs px-3.5 py-2.5 rounded-xl border border-[#2d313f] outline-none focus:border-theme-primary/60 transition-all placeholder:text-zinc-500 placeholder:opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                          onBlur={(e) => {
                            const val = e.target.value.trim();
                            const currentNotes = (activeBooking.notes || '').trim();
                            if (val !== currentNotes) {
                              handleUpdateBookingNotes(val);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.currentTarget.blur();
                            }
                          }}
                          disabled={activeBooking.status === 'paid'}
                        />
                      </div>
                    </div>

                    {/* Historial de Cobros */}
                    {activeBooking.paymentHistory && activeBooking.paymentHistory.length > 0 && (
                      <div className="bg-[#1a1c23] border border-[#2d313f] rounded-2xl p-4 shadow-sm relative overflow-hidden group">
                        <div className="flex items-center justify-between mb-2.5">
                          <span className="text-zinc-400 font-bold uppercase text-[9px] tracking-wider">{activeBooking.courtId === 'expense' ? 'Historial de Egresos' : 'Historial de Cobros'}</span>
                        </div>
                        <div className="space-y-3 max-h-[14rem] overflow-y-auto pr-2 custom-scrollbar">
                          {[...activeBooking.paymentHistory].reverse().map((entry, idx) => (
                            <div key={idx} className="flex flex-col gap-0.5 border-l-2 border-theme-primary/30 pl-3">
                              <div className="flex items-center justify-between">
                                <span className="text-[10px] font-black text-white uppercase tracking-wider">
                                  {entry.action === 'initial_charge' 
                                    ? ((activeBooking.paymentHistory.length - 1 - idx) > 0 ? 'Cobro' : 'Cobro Inicial') 
                                    : entry.action === 'modification' 
                                      ? 'Modificación' 
                                      : 'Anulación'}
                                </span>
                                <span className="text-[9px] text-zinc-500 font-bold">
                                  {new Date(entry.timestamp).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })} • {new Date(entry.timestamp).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                              </div>
                              <div className="text-[10px] text-zinc-300 flex flex-wrap gap-x-2 mt-0.5">
                                {entry.action !== 'annulment' ? (
                                  <>
                                    <span className={activeBooking.courtId === 'expense' ? "text-red-400 font-bold" : "text-lime-400 font-bold"}>${entry.newTotal?.toLocaleString('es-AR')}</span>
                                    <span>(Ef: ${entry.newCash?.toLocaleString('es-AR')} | Tr: ${entry.newTransfer?.toLocaleString('es-AR')})</span>
                                  </>
                                ) : (
                                  <span className="text-red-400 font-bold">Cobro Anulado</span>
                                )}
                              </div>
                              <div className="text-[9px] text-zinc-500 italic mt-0.5">
                                Por: {entry.by}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ACCIONES TÁCTILES DEL FONDO (Visible en Desktop al final de la columna izquierda) */}
                  <div className="hidden md:flex flex-col items-center justify-center gap-2 pt-3 pb-1 px-1 border-t border-[#2d313f] w-full mt-auto">
                    {showCobradoToast ? (
                      <div className="w-full bg-green-500/20 border border-green-500/40 text-green-300 py-3 px-4 rounded-xl text-xs font-black uppercase text-center flex items-center justify-center gap-2 animate-in fade-in zoom-in duration-200 shadow-lg">
                        <CheckCircle2 size={18} className="animate-bounce" /> ¡Cobrado!
                      </div>
                    ) : showCancelConfirmPopup ? (
                      <div className="w-full bg-[#15171d] border border-red-500/30 rounded-xl p-4 space-y-3 animate-in fade-in zoom-in-95 duration-200 shadow-xl">
                        <div className="text-center space-y-1">
                          <div className="flex items-center justify-center text-red-400 gap-1.5 font-black text-xs uppercase tracking-wider">
                            <AlertTriangle size={14} /> ¿Confirmar Cancelación?
                          </div>
                          {!(activeBooking?.courtId === 'pos_cantina' || activeBooking?.courtId === 'expense') && (
                          <p className="text-[11px] text-zinc-300 leading-snug">
                            {activeBooking.isFixed
                              ? "Esta reserva es fija. Elige cómo deseas cancelar:"
                              : "Al cancelar, la cancha quedará libre y se notificará al jugador."}
                          </p>
                        )}
                        </div>

                        {activeBooking.isFixed ? (
                          <div className="space-y-2 pt-1">
                            <button
                              onClick={async () => {
                                await executeDeleteBooking(activeBooking, 'single');
                                setShowCancelConfirmPopup(false);
                              }}
                              className="w-full bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-[#FFE600]/30 py-2.5 px-3 rounded-lg text-[11px] font-bold uppercase transition-all flex items-center justify-center gap-1.5 cursor-pointer shadow-md"
                            >
                              <Calendar size={13} /> Cancelar solo esta fecha
                            </button>
                            <button
                              onClick={async () => {
                                await executeDeleteBooking(activeBooking, 'all');
                                setShowCancelConfirmPopup(false);
                              }}
                              className="w-full bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30 py-2.5 px-3 rounded-lg text-[11px] font-bold uppercase transition-all flex items-center justify-center gap-1.5 cursor-pointer shadow-md"
                            >
                              <Trash2 size={13} /> Cancelar permanentemente (todas)
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2 pt-1 w-full">
                            <button
                              onClick={async () => {
                                await executeDeleteBooking(activeBooking, 'single');
                                setShowCancelConfirmPopup(false);
                              }}
                              className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 px-3 rounded-lg text-[11px] font-black uppercase transition-all cursor-pointer shadow-md shadow-red-500/20"
                            >
                              Sí, Cancelar
                            </button>
                            <button
                              onClick={() => setShowCancelConfirmPopup(false)}
                              className="flex-1 bg-[#222530] hover:bg-[#2d313f] border border-white/10 text-zinc-300 py-2 px-3 rounded-lg text-[11px] font-bold uppercase transition-all cursor-pointer"
                            >
                              Volver
                            </button>
                          </div>
                        )}

                        {activeBooking.isFixed && (
                          <button
                            onClick={() => setShowCancelConfirmPopup(false)}
                            className="w-full bg-[#222530] hover:bg-[#2d313f] border border-white/10 text-zinc-300 py-1.5 rounded-lg text-[10px] font-bold uppercase transition-all cursor-pointer mt-2"
                          >
                            Volver sin cancelar
                          </button>
                        )}
                      </div>
                    ) : (activeBooking.status === 'cancelled' || (activeBooking.hiddenFromGrid && activeBooking.courtId !== 'pos_cantina' && activeBooking.courtId !== 'expense')) ? null : (
                      <>
                        {/* Botón Cobrar (Si no está cobrado y NO está pendiente) */}
                        {activeBooking.status !== 'paid' &&
                          activeBooking.status !== 'pending' &&
                          (activeBooking.confirmationStatus !== 'pending_confirmation' || activeBooking.playerConfirmed) ? (
                          <button
                            onClick={() => {
                              setChargePaymentTotal(currentSlotBookingTotal.toString());
                              setChargePaymentCash('');
                              setChargePaymentTransfer(currentSlotBookingTotal.toString());
                              setShowChargeConfirmModal(true);
                            }}
                            className="w-full bg-[#72b512] hover:bg-[#84cc16] hover:scale-[1.02] active:scale-[0.98] cursor-pointer text-white border border-[#a3e635]/50 py-2 px-4 rounded-xl transition-all duration-200 flex flex-col items-center justify-center gap-0.5 shadow-lg shadow-lime-500/20 [text-shadow:0_0_4px_rgba(0,0,0,0.9)]"
                          >
                            <div className="flex items-center justify-center gap-1.5 text-sm font-black uppercase tracking-wider">
                              <DollarSign size={18} className="translate-y-[1px] -ml-[2px] drop-shadow-[0_0_4px_rgba(0,0,0,0.9)]" /> Cerrar / Registrar Turno
                            </div>
                            <span className="text-[11px] font-black normal-case tracking-normal text-zinc-700 [text-shadow:none] opacity-90">
                              Total: ${currentSlotBookingTotal.toLocaleString('es-AR')}
                            </span>
                          </button>
                        ) : activeBooking.status === 'paid' ? (
                          <div className="w-full flex flex-col gap-2">
                            <div className="w-full bg-lime-500/10 border border-lime-500/30 text-lime-400 py-3 px-3 rounded-xl text-[11px] font-black uppercase text-center flex items-center justify-center gap-1 shadow-[0_0_15px_rgba(132,204,22,0.15)]">
                              <CheckCircle2 size={14} /> {activeBooking.courtId === 'expense' ? 'Egreso Registrado' : activeBooking.courtId === 'pos_cantina' ? 'Venta Cobrada' : 'Turno Cobrado'}
                            </div>
                            {activeBooking.courtId !== 'expense' && (
                            <button
                              type="button"
                              onClick={async () => {
                                if (await window.confirm('¿Quieres anular el cobro?')) {
                                  handleUnmarkPaid(activeBooking!);
                                }
                              }}
                              className="w-full bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/20 py-2 px-3 rounded-xl text-[10px] font-bold uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-1 cursor-pointer shrink-0"
                              title="Anular o modificar registro de cobro"
                            >
                              <RotateCcw size={12} /> Anular / Modificar cobro
                            </button>
                            )}
                          </div>
                        ) : (
                          <div className="w-full bg-zinc-800/50 border border-zinc-700 text-zinc-500 py-3 px-4 rounded-xl text-[10px] font-bold uppercase text-center flex items-center justify-center gap-1.5 italic">
                            <AlertCircle size={13} /> El turno debe ser confirmado para cobrar
                          </div>
                        )}

                        {/* Botón Cancelar */}
                        <button
                          onClick={() => setShowCancelConfirmPopup(true)}
                          className="w-full bg-red-500/10 hover:bg-red-500/20 hover:scale-[1.02] active:scale-[0.98] cursor-pointer text-red-400 border border-red-500/20 py-1.5 px-3 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-1 mt-1"
                        >
                          <Trash2 size={12} /> {activeBooking?.courtId === 'pos_cantina' ? 'Cancelar Venta' : activeBooking?.courtId === 'expense' ? 'Cancelar Egreso' : 'Cancelar Reserva'}
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* COLUMNA DERECHA: DETALLE DEL TICKET (CANCHA, PRODUCTOS, TOTALES) */}
                <div className="md:col-span-3 flex flex-col min-h-0 space-y-3 md:pl-6 border-t md:border-t-0 md:border-l border-[#2d313f] pt-4 md:pt-0">
                  <div className="flex items-center justify-end lg:hidden">
                    {!showItemDropdown &&
                      activeBooking.status !== 'paid' &&
                      activeBooking.status !== 'pending' &&
                      activeBooking.status !== 'cancelled' &&
                      (activeBooking.confirmationStatus !== 'pending_confirmation' || activeBooking.playerConfirmed) && (
                        <button
                          onClick={() => setShowItemDropdown(true)}
                          className="text-theme-primary flex items-center gap-1.5 text-[10px] font-black uppercase bg-theme-primary/15 hover:bg-theme-primary/30 border border-theme-primary/30 hover:border-theme-primary/50 px-3 py-1.5 rounded-lg transition-all duration-200 hover:scale-105 hover:shadow-[0_0_12px_rgba(var(--glow-rgb),0.15)] active:scale-95 cursor-pointer lg:hidden"
                        >
                          <PlusCircle size={14} /> Agregar Item
                        </button>
                      )}
                  </div>

                  {/* Formulario para agregar producto (Con animación ultra fluida de Grid rows para acordión) */}
                  <div className={`grid transition-all duration-300 ease-out ${showItemDropdown ? 'grid-rows-[1fr] opacity-100 mt-2' : 'grid-rows-[0fr] opacity-0'} lg:grid-rows-[1fr] lg:opacity-100 lg:mt-0`}>
                    <div className="overflow-hidden space-y-3">
<CantinaProductSection
                          availableProducts={availableProducts}
                          activeBooking={activeBooking}
                          handleDirectAddToCart={handleDirectAddToCart}
                          handleRemoveFromTicket={handleRemoveFromTicket}
                        >
                          <button
                            onClick={() => {
                              if (activeBooking.status !== 'paid') {
                                setShowQuickItemModal(true);
                              }
                            }}
                            disabled={activeBooking.status === 'paid'}
                            className={`bg-transparent border border-blue-400 text-white shadow-md text-[10px] font-black uppercase px-3 py-1.5 rounded-xl transition-all duration-200 flex items-center justify-center gap-1 shrink-0 ${activeBooking.status === 'paid' ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-400/10 cursor-pointer'}`}
                          >
                            <Zap size={12} className="text-blue-400 fill-blue-400" /> Ítem Rápido
                          </button>
                        </CantinaProductSection>

                        <div className="flex justify-end pt-1 gap-2 lg:hidden">
                          <button
                            onClick={() => setShowQuickItemModal(true)}
                            className="bg-white hover:bg-white/90 text-black shadow-md text-[10px] font-black uppercase px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer flex items-center gap-1.5"
                          >
                            <Zap size={14} className="text-[#FFE600] fill-[#FFE600] stroke-yellow-600" /> Ítem Rápido
                          </button>
                          <button
                            onClick={() => {
                              setShowItemDropdown(false);
                            }}
                            className="bg-[#222530] border border-white/20 hover:border-white/40 hover:bg-[#2d313f] hover:text-white text-zinc-400 text-[10px] font-black uppercase px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer"
                          >
                            Cerrar
                          </button>
                        </div>

                        {/* MODAL ITEM RAPIDO */}
                        {showQuickItemModal && (
                          <div
                            className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 animate-in fade-in duration-200"
                            onMouseDown={(e) => {
                              if (e.target === e.currentTarget) {
                                setShowQuickItemModal(false);
                              }
                            }}
                          >
                            <div
                              className="bg-[#1a1c23] border border-[#FFE600]/30 rounded-2xl p-6 max-w-sm w-full space-y-5 shadow-2xl shadow-[#FFE600]/10 animate-in zoom-in-95 duration-200 relative"
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className="flex items-center justify-between border-b border-[#2d313f] pb-3">
                                <div className="flex items-center gap-2 text-[#FFE600]">
                                  <Zap size={16} className="fill-[#FFE600]" />
                                  <span className="text-xs font-black uppercase tracking-wider">Ítem Rápido (Provisorio)</span>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => setShowQuickItemModal(false)}
                                  className="text-zinc-400 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-all cursor-pointer"
                                >
                                  <X size={16} />
                                </button>
                              </div>

                              <div className="space-y-4">
                                <div className="space-y-1.5">
                                  <label className="block text-[10px] font-bold uppercase tracking-wider text-zinc-400 text-left">Nombre / Concepto</label>
                                  <input
                                    type="text"
                                    placeholder="Ej: Alquiler Paleta..."
                                    key={quickItemName} defaultValue={quickItemName}
                                      onBlur={e => setQuickItemName(e.target.value)}
                                    className="w-full bg-[#222530] h-10 text-xs text-white font-semibold rounded-xl px-3 border border-[#2d313f] outline-none placeholder:text-zinc-600 focus:border-[#FFE600]/60 transition-all"
                                  />
                                </div>
                                
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-[10px] font-bold uppercase tracking-wider text-zinc-400 text-left">Precio Unitario</label>
                                    <div className="relative">
                                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 font-bold">$</span>
                                      <input
                                        type="text"
                                        inputMode="numeric"
                                        placeholder="0"
                                        key={quickItemPrice} defaultValue={quickItemPrice}
                                        onBlur={e => { const val = e.target.value.replace(/\D/g, ''); setQuickItemPrice(val ? Number(val) : ''); }}
                                        className="w-full bg-[#222530] h-10 text-xs text-white font-semibold rounded-xl pl-7 pr-3 border border-[#2d313f] outline-none placeholder:text-zinc-600 focus:border-[#FFE600]/60 transition-all"
                                      />
                                    </div>
                                  </div>

                                  <div className="space-y-1.5">
                                    <label className="block text-[10px] font-bold uppercase tracking-wider text-zinc-400 text-left">Cantidad</label>
                                    <div className="flex items-center bg-[#222530] rounded-xl border border-[#2d313f] overflow-hidden h-10">
                                      <button
                                        type="button"
                                        onClick={() => setQuickItemQuantity(q => Math.max(1, q - 1))}
                                        className="w-10 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 active:scale-90 transition-all font-black text-base cursor-pointer select-none border-r border-[#2d313f]"
                                      >
                                        -
                                      </button>
                                      <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        key={quickItemQuantity} defaultValue={quickItemQuantity}
                                        onBlur={e => setQuickItemQuantity(parseInt(e.target.value) || 1)}
                                        className="w-full h-full bg-transparent text-sm text-white outline-none text-center font-black"
                                      />
                                      <button
                                        type="button"
                                        onClick={() => setQuickItemQuantity(q => q + 1)}
                                        className="w-10 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 active:scale-90 transition-all font-black text-base cursor-pointer select-none border-l border-[#2d313f]"
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="flex items-center gap-2 pt-2">
                                <button
                                  onClick={handleAddQuickItem}
                                  disabled={!quickItemName.trim() || quickItemPrice === ''}
                                  className="flex-1 bg-[#FFE600] hover:bg-[#e6d000] disabled:bg-zinc-700 disabled:text-zinc-500 text-black font-black uppercase text-[11px] py-3 px-4 rounded-xl hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-[#FFE600]/10 flex items-center justify-center gap-1.5 cursor-pointer"
                                >
                                  Agregar al Ticket {(quickItemPrice !== '' && quickItemQuantity > 0) ? `($${(Number(quickItemPrice) * quickItemQuantity).toLocaleString('es-AR')})` : ''}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Contenido del Ticket */}
                  {(activeBooking.status === 'pending' || activeBooking.confirmationStatus === 'pending_confirmation') && !activeBooking.playerConfirmed ? (
                    <div className="flex-1 bg-[#15171d] rounded-2xl border border-[#2d313f] flex flex-col items-center justify-center p-8 text-center space-y-4 min-h-[300px]">
                      <div className="w-16 h-16 rounded-full bg-amber-500/10 flex items-center justify-center border border-amber-500/20 shadow-[0_0_20px_rgba(245,158,11,0.05)]">
                        <Clock size={28} className="text-[#FFE600]/60 animate-pulse" />
                      </div>
                      <div className="space-y-2">
                        <h5 className="text-xs font-black text-[#FFE600]/80 uppercase tracking-widest">Turno en Revisión</h5>
                        <p className="text-[11px] text-zinc-500 leading-relaxed max-w-[240px] mx-auto">
                          La gestión de consumos y el cobro se habilitarán una vez que la asistencia sea <b>confirmada</b>.
                        </p>
                      </div>
                      <div className="pt-2">
                        <div className="px-3 py-1 bg-zinc-800/50 rounded-full border border-zinc-700/50 inline-flex items-center gap-2">
                          <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" />
                          <span className="text-[9px] font-bold text-zinc-400 uppercase tracking-tighter">Esperando Confirmación</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* Encabezado de columnas */}
                      <div className="flex items-center gap-1 sm:gap-2 px-1 sm:px-3 pb-1.5 text-[8px] sm:text-[9px] font-bold tracking-wider text-zinc-500 uppercase border-b border-[#2d313f] select-none text-center">
                        <div className="flex-1 text-left min-w-0">Ítem</div>
                        <div className="shrink-0 w-[60px] sm:w-[75px]">Cantidad</div>
                        <div className="shrink-0 w-[100px] sm:w-[120px]">Pago Parcial</div>
                        <div className="shrink-0 w-[55px] sm:w-[70px] md:w-[85px] text-right pr-1">Valor</div>
                      </div>

                      {/* Lista de items del Ticket */}
                      <div className="flex-1 min-h-[180px] sm:min-h-[200px] space-y-2 overflow-y-auto pr-1 custom-scrollbar">
                        {/* 1. Valor de la Cancha (Siempre presente y editable) */}
                        {activeBooking?.courtId !== 'pos_cantina' && activeBooking?.courtId !== 'expense' && (
                        <div className="flex items-center gap-1 sm:gap-2 bg-[#222530] p-1.5 sm:p-2 rounded-xl border border-[#2d313f] hover:border-zinc-700 transition-all duration-200">
                          <div className="flex-1 flex items-center gap-1.5 min-w-0">
                            <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-theme-primary/10 flex items-center justify-center border border-theme-primary/20 shrink-0">
                              <DollarSign size={13} className="text-theme-primary" />
                            </div>
                            <div className="min-w-0 flex-1 flex flex-col justify-center">
                              <div className="flex items-center gap-2">
                                <span className="text-white/90 font-semibold text-[9px] sm:text-[10px] leading-tight line-clamp-1 whitespace-nowrap">Cancha (alquiler)</span>
                                {isEditingDiscount ? (
                                  <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                                    <input
                                      type="number"
                                      min="0"
                                      max="100"
                                      defaultValue={tempDiscount}
                                      className="w-10 sm:w-12 bg-[#15171d] text-green-400 text-[9px] sm:text-[10px] font-black px-1 py-0.5 rounded border border-green-500/50 outline-none text-center focus:ring-1 focus:ring-green-500"
                                      placeholder="%"
                                      autoFocus
                                      onFocus={(e) => e.target.select()}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          handleSaveDiscountPercent(Number(e.currentTarget.value) || 0);
                                          setIsEditingDiscount(false);
                                        } else if (e.key === 'Escape') {
                                          setIsEditingDiscount(false);
                                        }
                                      }}
                                    />
                                    <button
                                      onClick={(e) => {
                                        const input = e.currentTarget.previousElementSibling as HTMLInputElement;
                                        handleSaveDiscountPercent(Number(input.value) || 0);
                                        setIsEditingDiscount(false);
                                      }}
                                      className="p-0.5 bg-green-500/20 hover:bg-green-500 text-green-400 hover:text-black rounded transition-all cursor-pointer"
                                      title="Guardar"
                                    >
                                      <Check size={10} />
                                    </button>
                                    <button
                                      onClick={() => setIsEditingDiscount(false)}
                                      className="p-0.5 bg-white/5 hover:bg-white/10 text-zinc-400 hover:text-white rounded transition-all cursor-pointer"
                                      title="Cancelar"
                                    >
                                      <X size={10} />
                                    </button>
                                  </div>
                                ) : activeBooking.status !== 'paid' ? (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setTempDiscount(String(currentDiscountPercent));
                                      setIsEditingDiscount(true);
                                    }}
                                    className={`text-[8px] sm:text-[9px] font-bold uppercase px-1 py-0.5 rounded border transition-all cursor-pointer hover:scale-[1.03] active:scale-[0.97] w-fit shrink-0 ${currentDiscountPercent > 0
                                      ? 'text-green-400 bg-green-500/10 border-green-500/30 hover:bg-green-500/20'
                                      : 'text-zinc-400 bg-[#15171d] border-[#2d313f] hover:bg-zinc-800'
                                      }`}
                                    title="Editar Descuento"
                                  >
                                    {currentDiscountPercent}% desc
                                  </button>
                                ) : (
                                  <span className={`text-[8px] sm:text-[9px] font-bold uppercase px-1 py-0.5 rounded border select-none w-fit shrink-0 ${currentDiscountPercent > 0
                                    ? 'text-green-400 bg-green-500/10 border-green-500/20'
                                    : 'text-zinc-500 bg-[#15171d] border-[#2d313f]'
                                    }`}>
                                    {currentDiscountPercent}% desc
                                  </span>
                                )}
                              </div>
                              {activeBooking?.status !== 'paid' && activeBooking?.status !== 'cancelled' ? (
                                <input
                                  type="text"
                                  defaultValue={activeBooking?.courtPriceNote || ''}
                                  placeholder="Añadir nota..."
                                  onBlur={(e) => {
                                    const val = e.target.value.trim();
                                    if (val !== (activeBooking?.courtPriceNote || '').trim()) {
                                      ensureMaterialized(activeBooking, { courtPriceNote: val });
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') e.currentTarget.blur();
                                  }}
                                  className="bg-transparent border-none outline-none text-zinc-400 text-[9px] sm:text-[10px] block w-full placeholder:text-zinc-600 focus:text-theme-primary transition-colors h-4"
                                />
                              ) : (
                                activeBooking?.courtPriceNote && <span className="text-zinc-400 text-[9px] sm:text-[10px] block truncate">{activeBooking.courtPriceNote}</span>
                              )}
                            </div>
                          </div>

                          <div className="shrink-0 w-[60px] sm:w-[75px] flex items-center justify-center">
                            <span className="text-zinc-400 font-bold text-[10px] sm:text-[11px] px-1.5 py-0.5 bg-[#15171d] border border-[#2d313f] rounded-lg select-none">
                              x1
                            </span>
                          </div>

                          <div className="shrink-0 w-[100px] sm:w-[120px] flex items-center justify-center min-w-0">
                            {activeBooking && activeBooking.status !== 'paid' ? (
                              (activeBooking.courtPaidPlayersCount || 0) > 0 ? (
                                <div className="flex items-center gap-1 sm:gap-1.5 bg-[#2d313f] p-1 rounded-lg border border-zinc-700/50 max-w-full">
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleUpdateCourtPaidPlayers(0);
                                    }}
                                    className="w-6 sm:w-7 h-3.5 sm:h-4 bg-green-500 rounded-full p-0.5 flex items-center transition-all cursor-pointer shrink-0 shadow-[0_0_8px_rgba(34,197,94,0.4)]"
                                    title="Desactivar cobro parcial"
                                  >
                                    <div className="w-2.5 sm:w-3 h-2.5 sm:h-3 bg-black rounded-full shadow-md transform translate-x-2.5 sm:translate-x-3 transition-transform" />
                                  </button>

                                  <div className="flex items-center bg-[#15171d]/90 border border-[#2d313f] rounded-md overflow-hidden h-5 sm:h-6">
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        const current = activeBooking.courtPaidPlayersCount || 1;
                                        if (current > 1) {
                                          const nextNode = e.currentTarget.nextElementSibling;
                                          if (nextNode) nextNode.textContent = String(current - 1) + '/4';
                                          setTimeout(() => handleUpdateCourtPaidPlayers(current - 1), 0);
                                        }
                                      }}
                                      disabled={(activeBooking.courtPaidPlayersCount || 1) <= 1}
                                      className="w-5 sm:w-6 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5 active:scale-90 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-[11px] sm:text-xs font-black cursor-pointer select-none border-r border-[#2d313f]"
                                      title="Disminuir"
                                    >
                                      -
                                    </button>
                                    <span className="text-green-400 font-bold text-[9px] sm:text-[10px] px-2 text-center min-w-[28px] sm:min-w-[32px] select-none">
                                      {activeBooking.courtPaidPlayersCount || 1}/4
                                    </span>
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        const current = activeBooking.courtPaidPlayersCount || 1;
                                        if (current < 4) {
                                          const prevNode = e.currentTarget.previousElementSibling;
                                          if (prevNode) prevNode.textContent = String(current + 1) + '/4';
                                          setTimeout(() => handleUpdateCourtPaidPlayers(current + 1), 0);
                                        }
                                      }}
                                      disabled={(activeBooking.courtPaidPlayersCount || 1) >= 4}
                                      className="w-5 sm:w-6 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5 active:scale-90 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-[11px] sm:text-xs font-black cursor-pointer select-none border-l border-[#2d313f]"
                                      title="Aumentar"
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex items-center justify-center">
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleUpdateCourtPaidPlayers(tempCourtSelect || 1);
                                    }}
                                    className="w-8 h-4 bg-[#15171d] border border-zinc-700/50 rounded-full p-0.5 flex items-center transition-all cursor-pointer hover:border-zinc-500"
                                    title="Activar cobro parcial"
                                  >
                                    <div className="w-3 h-3 bg-zinc-500 rounded-full shadow-md transform translate-x-0 transition-transform" />
                                  </button>
                                </div>
                              )
                            ) : (
                              <span className="text-zinc-500 text-[9px] sm:text-[10px] italic">{activeBooking?.status === 'cancelled' ? 'Cancelado' : 'Cobrado'}</span>
                            )}
                          </div>

                          <div className="shrink-0 w-[55px] sm:w-[70px] md:w-[85px] flex items-center justify-end gap-0.5 min-w-0 pr-0.5">
                            {isEditingPrice ? (
                              <div className="flex items-center gap-0.5">
                                <span className="text-zinc-400 font-bold text-[10px]">$</span>
                                <input
                                  type="number"
                                  defaultValue={tempPrice}
                                  className="w-14 bg-[#15171d] text-white text-[8px] sm:text-[10px] font-black px-1 py-0.5 rounded-lg border border-theme-primary/50 text-right outline-none focus:ring-1 focus:ring-theme-primary"
                                  placeholder="Monto"
                                  autoFocus
                                  onFocus={(e) => e.target.select()}
                                  onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        handleUpdateBookingPrice(Number(e.currentTarget.value) || 0);
                                        setIsEditingPrice(false);
                                      } else if (e.key === 'Escape') {
                                        setIsEditingPrice(false);
                                      }
                                    }}
                                />
                                <button
                                  onClick={(e) => {
                                    const input = e.currentTarget.previousElementSibling;
                                    handleUpdateBookingPrice(Number(input.value) || 0);
                                    setIsEditingPrice(false);
                                  }}
                                  className="p-1 bg-green-500/20 hover:bg-green-500 text-green-400 hover:text-black rounded-md transition-all cursor-pointer shrink-0"
                                  title="Guardar"
                                >
                                  <Check size={9} />
                                </button>
                                <button
                                  onClick={() => setIsEditingPrice(false)}
                                  className="p-1 bg-zinc-500/20 hover:bg-zinc-500 text-zinc-400 hover:text-black rounded-md transition-all cursor-pointer shrink-0"
                                  title="Cancelar"
                                >
                                  <X size={9} />
                                </button>
                              </div>
                            ) : (
                              <>
                                <span className="text-zinc-200 font-bold text-[8px] sm:text-[9px] md:text-[11px] text-right truncate">
                                  ${(activeBooking?.price ?? schedule?.pricePerSlot ?? 12000).toLocaleString('es-AR')}
                                </span>
                                {activeBooking?.status !== 'paid' && activeBooking?.status !== 'cancelled' && (
                                  <button
                                    onClick={() => {
                                      setTempPrice(String(activeBooking?.price ?? schedule?.pricePerSlot ?? 12000));
                                      setIsEditingPrice(true);
                                    }}
                                    className="text-zinc-400 hover:text-theme-primary p-1 hover:bg-[#2d313f] rounded-lg transition-all cursor-pointer shrink-0 ml-0.5 md:ml-1"
                                    title="Editar precio"
                                  >
                                    <Pencil className="w-[9px] h-[9px] sm:w-[9px] sm:h-[9px] md:w-[11px] md:h-[11px]" />
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                        )}

                        {/* 2. Items / Consumos Extra */}
                        {bookingItems.map(item => (
                          <div key={item.id} className="flex items-center gap-1 sm:gap-2 bg-[#222530] p-1.5 sm:p-2 rounded-xl border border-[#2d313f] hover:border-zinc-700 hover:bg-[#282b3a] transition-all duration-200 animate-in fade-in duration-150">
                            <div className="flex-1 flex items-center gap-1.5 min-w-0">
                              {(() => {
                                const prodImg = item.imageUrl || availableProducts.find(p => p.id === item.id)?.imageUrl;
                                return prodImg ? (
                                  <img
                                    src={prodImg}
                                    alt={item.name}
                                    className="w-6 h-6 sm:w-7 sm:h-7 rounded-md object-cover border border-[#2d313f] shrink-0"
                                  />
                                ) : (
                                  <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-[#15171d] flex items-center justify-center border border-[#2d313f] shrink-0">
                                    <ImageIcon size={13} className="text-zinc-500" />
                                  </div>
                                );
                              })()}
                              <div className="min-w-0 flex-1 flex flex-col justify-center">
                                <span className="text-white/90 font-semibold text-[9px] sm:text-[10px] leading-tight line-clamp-1">{item.name}</span>
                                {activeBooking?.status !== 'paid' && activeBooking?.status !== 'cancelled' ? (
                                  <input
                                    type="text"
                                    defaultValue={item.note || ''}
                                    placeholder="Añadir nota..."
                                    onBlur={(e) => {
                                      const val = e.target.value.trim();
                                      if (val !== (item.note || '').trim()) {
                                        const updatedItems = bookingItems.map(i => i.id === item.id ? { ...i, note: val } : i);
                                        ensureMaterialized(activeBooking, { items: updatedItems });
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') e.currentTarget.blur();
                                    }}
                                    className="bg-transparent border-none outline-none text-zinc-400 text-[9px] sm:text-[10px] block w-full mt-0.5 placeholder:text-zinc-600 focus:text-theme-primary transition-colors"
                                  />
                                ) : (
                                  item.note && <span className="text-zinc-400 text-[9px] sm:text-[10px] block truncate mt-0.5">{item.note}</span>
                                )}
                              </div>
                            </div>

                            <div className="shrink-0 w-[60px] sm:w-[75px] flex items-center justify-center">
                              {activeBooking?.status !== 'paid' && activeBooking?.status !== 'cancelled' ? (
                                <div className="flex items-center bg-[#15171d]/90 border border-[#2d313f] rounded-lg overflow-hidden h-5 sm:h-6">
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      if (item.quantity > 1) {
                                        const nextNode = e.currentTarget.nextElementSibling;
                                        if (nextNode) nextNode.textContent = String(item.quantity - 1);
                                        setTimeout(() => handleUpdateItemQuantity(item.id, item.quantity - 1), 0);
                                      } else if (item.quantity === 1) {
                                        // Atajo: estando en 1, presionar '-' divide el producto en partes
                                        const currentParts = item.splitParts || 1;
                                        const nextParts = currentParts === 1 ? 2 : (currentParts < 8 ? currentParts + 1 : 2);
                                        const paid = item.paidCount && item.paidCount > 0 ? Math.min(item.paidCount, nextParts) : 1;
                                        handleUpdateItemPaidCount(item.id, paid, nextParts);
                                      }
                                    }}
                                    className="w-4 sm:w-5 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5 active:scale-90 transition-all text-[11px] sm:text-xs font-black cursor-pointer select-none border-r border-[#2d313f]"
                                    title={item.quantity === 1 ? (item.splitParts && item.splitParts > 1 ? `Dividido en ${item.splitParts}. Clic para dividir en ${item.splitParts + 1}` : "Dividir producto (1/2, 1/3...)") : "Disminuir cantidad"}
                                  >
                                    -
                                  </button>
                                  <span key={`qty-${item.quantity}-${item.splitParts || 1}`} className="text-theme-primary font-bold text-[9px] sm:text-[10px] px-1 sm:px-1.5 text-center min-w-[16px] sm:min-w-[20px] select-none" title={item.splitParts && item.splitParts > 1 ? `1 unidad dividida en ${item.splitParts} partes` : undefined}>
                                    {item.quantity === 1 && item.splitParts && item.splitParts > 1 ? `1/${item.splitParts}` : item.quantity}
                                  </span>
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      if (item.quantity === 1 && item.splitParts && item.splitParts > 1) {
                                        if (item.splitParts > 2) {
                                          const nextParts = item.splitParts - 1;
                                          const paid = Math.min(item.paidCount || 1, nextParts);
                                          handleUpdateItemPaidCount(item.id, paid, nextParts);
                                        } else {
                                          // Estando en 1/2, al tocar '+' se desactiva el pago parcial y vuelve a 1 unidad única
                                          handleUpdateItemPaidCount(item.id, 0);
                                        }
                                      } else {
                                        const prevNode = e.currentTarget.previousElementSibling;
                                        if (prevNode) prevNode.textContent = String(item.quantity + 1);
                                        setTimeout(() => handleUpdateItemQuantity(item.id, item.quantity + 1), 0);
                                      }
                                    }}
                                    className="w-4 sm:w-5 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5 active:scale-90 transition-all text-[11px] sm:text-xs font-black cursor-pointer select-none border-l border-[#2d313f]"
                                    title={item.quantity === 1 && item.splitParts && item.splitParts > 1 ? (item.splitParts === 2 ? "Volver a 1 unidad entera (desactiva pago parcial)" : "Reducir división") : "Aumentar cantidad"}
                                  >
                                    +
                                  </button>
                                </div>
                              ) : (
                                <span className="text-zinc-400 font-bold text-[10px] sm:text-[11px] px-1.5 py-0.5 bg-[#15171d] border border-[#2d313f] rounded-lg select-none">
                                  {item.quantity === 1 && item.splitParts && item.splitParts > 1 ? `x1/${item.splitParts}` : `x${item.quantity}`}
                                </span>
                              )}
                            </div>

                            <div className="shrink-0 w-[100px] sm:w-[120px] flex items-center justify-center min-w-0">
                              {activeBooking?.status !== 'paid' && activeBooking?.status !== 'cancelled' ? (
                                (item.paidCount || 0) > 0 ? (
                                  <div className="flex items-center gap-1 bg-[#2d313f] p-0.5 sm:p-1 rounded-lg border border-zinc-700/50 max-w-full">
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleUpdateItemPaidCount(item.id, 0);
                                      }}
                                      className="w-5 sm:w-6 h-3 sm:h-3.5 bg-green-500 rounded-full p-0.5 flex items-center transition-all cursor-pointer shrink-0 shadow-[0_0_8px_rgba(34,197,94,0.4)] hover:brightness-110 active:scale-95"
                                      title="Desactivar cobro parcial"
                                    >
                                      <div className="w-2 sm:w-2.5 h-2 sm:h-2.5 bg-black rounded-full shadow-md transform translate-x-2 sm:translate-x-2.5 transition-transform pointer-events-none" />
                                    </button>

                                    {/* Selector de partes pagadas / total partes */}
                                    {(() => {
                                      const totalParts = item.splitParts || item.quantity;
                                      const currentPaid = item.paidCount || 1;
                                      return (
                                        <div className="flex items-center bg-[#15171d]/90 border border-[#2d313f] rounded-md overflow-hidden h-5 sm:h-6">
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (currentPaid > 1) {
                                                handleUpdateItemPaidCount(item.id, currentPaid - 1, totalParts);
                                              }
                                            }}
                                            disabled={currentPaid <= 1}
                                            className="w-4 sm:w-5 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5 active:scale-90 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-[11px] sm:text-xs font-black cursor-pointer select-none border-r border-[#2d313f]"
                                            title="Menos partes pagadas"
                                          >
                                            -
                                          </button>
                                          <span key={`paid-${currentPaid}-${totalParts}`} className="text-green-400 font-bold text-[9px] sm:text-[10px] px-1 sm:px-1.5 text-center min-w-[26px] sm:min-w-[30px] select-none whitespace-nowrap" title={`Pagado ${currentPaid} de ${totalParts} partes`}>
                                            {currentPaid}/{totalParts}
                                          </span>
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (currentPaid < totalParts) {
                                                handleUpdateItemPaidCount(item.id, currentPaid + 1, totalParts);
                                              }
                                            }}
                                            disabled={currentPaid >= totalParts}
                                            className="w-4 sm:w-5 h-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5 active:scale-90 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-[11px] sm:text-xs font-black cursor-pointer select-none border-l border-[#2d313f]"
                                            title="Más partes pagadas"
                                          >
                                            +
                                          </button>
                                        </div>
                                      );
                                    })()}
                                  </div>
                                ) : (
                                  <div className="flex items-center justify-center">
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // Si la cantidad es 1, al encender pago parcial por defecto ofrece dividir en 2 partes
                                        const defaultParts = item.quantity === 1 ? 2 : item.quantity;
                                        handleUpdateItemPaidCount(item.id, 1, defaultParts);
                                      }}
                                      className="w-8 h-4 bg-[#15171d] border border-zinc-700/50 rounded-full p-0.5 flex items-center transition-all cursor-pointer hover:border-zinc-500 active:scale-95"
                                      title={item.quantity === 1 ? "Activar cobro parcial (dividir en 2 partes)" : "Activar cobro parcial"}
                                    >
                                      <div className="w-3 h-3 bg-zinc-500 rounded-full shadow-md transform translate-x-0 transition-transform pointer-events-none" />
                                    </button>
                                  </div>
                                )
                              ) : (
                                <span className="text-zinc-500 text-[9px] sm:text-[10px] italic">Cobrado</span>
                              )}
                            </div>

                            <div className="shrink-0 w-[55px] sm:w-[70px] md:w-[85px] flex items-center justify-end gap-0.5 min-w-0 pr-0.5">
                              <span className="text-zinc-200 font-bold text-[8px] sm:text-[9px] text-right truncate">${(item.price * item.quantity).toLocaleString('es-AR')}</span>
                              {activeBooking?.status !== 'paid' && activeBooking?.status !== 'cancelled' && (
                                <button
                                  onClick={() => handleRemoveProductFromSlot(item.id)}
                                  className="text-red-400 hover:text-white p-1 bg-red-500/10 hover:bg-red-500/30 rounded-lg transition-all duration-200 hover:scale-110 active:scale-90 cursor-pointer shrink-0 ml-0.5"
                                  title="Quitar consumo"
                                >
                                  <Trash2 size={10} />
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Detalle Total con Desglose de Pagos Parciales */}
                      <div className="flex flex-col gap-1 p-2 bg-gradient-to-r from-theme-primary/10 to-transparent rounded-xl border border-theme-primary/20 mt-1">
                        {activeBooking.status === 'paid' ? (
                          <div className="flex flex-col gap-1">
                            <div className="flex items-center justify-between">
                              <span className="text-white font-black uppercase tracking-wider text-xs">{activeBooking.courtId === 'expense' ? 'Total Egresado' : 'Total Cobrado'}</span>
                              <span className={activeBooking.courtId === 'expense' ? "text-red-400 font-black text-lg" : "text-lime-400 font-black text-lg"}>${((activeBooking.paymentBreakdown?.cash || 0) + (activeBooking.paymentBreakdown?.transfer || 0)).toLocaleString('es-AR')}</span>
                            </div>
                            {activeBooking.paymentHistory && activeBooking.paymentHistory.length > 0 && activeBooking.paymentHistory[activeBooking.paymentHistory.length - 1].action === 'modification' && (
                              <div className="text-[10px] text-zinc-400 text-right italic mt-1">
                                Última modificación por {activeBooking.paymentHistory[activeBooking.paymentHistory.length - 1].by}
                              </div>
                            )}
                          </div>
                        ) : (
                          <>
                            <div className="flex items-center justify-between">
                              <span className="text-zinc-400 font-bold uppercase tracking-wider text-[10px]">Total General</span>
                              <span className="text-white font-bold text-xs">${currentSlotBookingTotal.toLocaleString('es-AR')}</span>
                            </div>

                            {currentSlotPaidTotal > 0 && (
                              <div className="flex items-center justify-between text-green-400 animate-in fade-in duration-200">
                                <span className="font-bold uppercase tracking-wider text-[10px]">Pagado</span>
                                <span className="font-black text-xs">-${currentSlotPaidTotal.toLocaleString('es-AR')}</span>
                              </div>
                            )}

                            <div className="flex items-center justify-between pt-1 border-t border-white/10 mt-0.5">
                              <span className="text-white font-black uppercase tracking-wider text-[11px]">Restante a Cobrar</span>
                              <div className="flex flex-col items-end">
                                <span className="text-theme-primary font-black text-lg">${currentSlotRemainingTotal.toLocaleString('es-AR')}</span>
                                {currentSlotPaidTotal === 0 && (
                                  <span className="text-zinc-400 font-medium text-[10px]">${(currentSlotBookingTotal / 4).toLocaleString('es-AR', { maximumFractionDigits: 0 })} por jugador</span>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      {/* ACCIONES TÁCTILES DEL FONDO (Visible en Móvil al final de todo el modal) */}
                      <div className="flex md:hidden flex-col items-center justify-center gap-2 pt-4 pb-2 px-1 border-t border-[#2d313f] w-full mt-4">
                        {showCobradoToast ? (
                          <div className="w-full bg-green-500/20 border border-green-500/40 text-green-300 py-3 px-4 rounded-xl text-xs font-black uppercase text-center flex items-center justify-center gap-2 animate-in fade-in zoom-in duration-200 shadow-lg">
                            <CheckCircle2 size={18} className="animate-bounce" /> ¡Cobrado!
                          </div>
                        ) : showCancelConfirmPopup ? (
                          <div className="w-full bg-[#15171d] border border-red-500/30 rounded-xl p-4 space-y-3 animate-in fade-in zoom-in-95 duration-200 shadow-xl">
                            <div className="text-center space-y-1">
                              <div className="flex items-center justify-center text-red-400 gap-1.5 font-black text-xs uppercase tracking-wider">
                                <AlertTriangle size={14} /> ¿Confirmar Cancelación?
                              </div>
                              {!(activeBooking?.courtId === 'pos_cantina' || activeBooking?.courtId === 'expense') && (
                          <p className="text-[11px] text-zinc-300 leading-snug">
                            {activeBooking.isFixed
                              ? "Esta reserva es fija. Elige cómo deseas cancelar:"
                              : "Al cancelar, la cancha quedará libre y se notificará al jugador."}
                          </p>
                        )}
                            </div>

                            {activeBooking.isFixed ? (
                              <div className="space-y-2 pt-1">
                                <button
                                  onClick={async () => {
                                    await executeDeleteBooking(activeBooking, 'single');
                                    setShowCancelConfirmPopup(false);
                                  }}
                                  className="w-full bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-[#FFE600]/30 py-2.5 px-3 rounded-lg text-[11px] font-bold uppercase transition-all flex items-center justify-center gap-1.5 cursor-pointer shadow-md"
                                >
                                  <Calendar size={13} /> Cancelar solo esta fecha
                                </button>
                                <button
                                  onClick={async () => {
                                    await executeDeleteBooking(activeBooking, 'all');
                                    setShowCancelConfirmPopup(false);
                                  }}
                                  className="w-full bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30 py-2.5 px-3 rounded-lg text-[11px] font-bold uppercase transition-all flex items-center justify-center gap-1.5 cursor-pointer shadow-md"
                                >
                                  <Trash2 size={13} /> Cancelar permanentemente (todas)
                                </button>
                              </div>
                            ) : (
                              <div className="flex items-center gap-2 pt-1 w-full">
                                <button
                                  onClick={() => {
                                    executeDeleteBooking(activeBooking, 'single');
                                    setShowCancelConfirmPopup(false);
                                  }}
                                  className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 px-3 rounded-lg text-[11px] font-black uppercase transition-all cursor-pointer shadow-md shadow-red-500/20"
                                >
                                  Sí, Cancelar
                                </button>
                                <button
                                  onClick={() => setShowCancelConfirmPopup(false)}
                                  className="flex-1 bg-[#222530] hover:bg-[#2d313f] border border-white/10 text-zinc-300 py-2 px-3 rounded-lg text-[11px] font-bold uppercase transition-all cursor-pointer"
                                >
                                  Volver
                                </button>
                              </div>
                            )}

                            {activeBooking.isFixed && (
                              <button
                                onClick={() => setShowCancelConfirmPopup(false)}
                                className="w-full bg-[#222530] hover:bg-[#2d313f] border border-white/10 text-zinc-300 py-1.5 rounded-lg text-[10px] font-bold uppercase transition-all cursor-pointer mt-2"
                              >
                                Volver sin cancelar
                              </button>
                            )}
                          </div>
                        ) : (activeBooking.status === 'cancelled' || (activeBooking.hiddenFromGrid && activeBooking.courtId !== 'pos_cantina' && activeBooking.courtId !== 'expense')) ? null : (
                          <>
                            {/* Botón Cobrar (Si no está cobrado) */}
                            {activeBooking.status !== 'paid' ? (
                              <button
                                onClick={() => {
                                  setChargePaymentTotal(currentSlotBookingTotal.toString());
                              setChargePaymentCash('');
                              setChargePaymentTransfer(currentSlotBookingTotal.toString());
                                  setShowChargeConfirmModal(true);
                                }}
                                className="w-full bg-[#72b512] hover:bg-[#84cc16] hover:scale-[1.02] active:scale-[0.98] cursor-pointer text-white border border-[#a3e635]/50 py-2 px-4 rounded-xl transition-all duration-200 flex flex-col items-center justify-center gap-0.5 shadow-lg shadow-lime-500/20 [text-shadow:0_0_4px_rgba(0,0,0,0.9)]"
                              >
                                <div className="flex items-center justify-center gap-1.5 text-sm font-black uppercase tracking-wider">
                                  <DollarSign size={18} className="translate-y-[1px] -ml-[2px] drop-shadow-[0_0_4px_rgba(0,0,0,0.9)]" /> Cerrar / Registrar Turno
                                </div>
                                <span className="text-[11px] font-black normal-case tracking-normal text-zinc-700 [text-shadow:none] opacity-90">
                                  Total: ${currentSlotBookingTotal.toLocaleString('es-AR')}
                                </span>
                              </button>
                            ) : (
                              <div className="w-full flex flex-col gap-2">
                                <div className="w-full bg-lime-500/10 border border-lime-500/30 text-lime-400 py-3 px-3 rounded-xl text-[11px] font-black uppercase text-center flex items-center justify-center gap-1 shadow-[0_0_15px_rgba(132,204,22,0.15)]">
                                  <CheckCircle2 size={14} /> {activeBooking.courtId === 'expense' ? 'Egreso Registrado' : activeBooking.courtId === 'pos_cantina' ? 'Venta Cobrada' : 'Turno Cobrado'}
                                </div>
                                {activeBooking.courtId !== 'expense' && (
                                <button
                              type="button"
                              onClick={async () => {
                                if (await window.confirm('¿Quieres anular el cobro?')) {
                                  handleUnmarkPaid(activeBooking!);
                                }
                              }}
                              className="w-full bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/20 py-2 px-3 rounded-xl text-[10px] font-bold uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-1 cursor-pointer shrink-0"
                              title="Anular o modificar registro de cobro"
                            >
                              <RotateCcw size={12} /> Anular / Modificar cobro
                            </button>
                            )}
                              </div>
                            )}

                            {/* Botón Cancelar */}
                            <button
                              onClick={() => setShowCancelConfirmPopup(true)}
                              className="w-full bg-red-500/10 hover:bg-red-500/20 hover:scale-[1.02] active:scale-[0.98] cursor-pointer text-red-400 border border-red-500/20 py-1.5 px-3 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all duration-200 flex items-center justify-center gap-1 mt-1"
                            >
                              <Trash2 size={12} /> {activeBooking?.courtId === 'pos_cantina' ? 'Cancelar Venta' : activeBooking?.courtId === 'expense' ? 'Cancelar Egreso' : 'Cancelar Reserva'}
                            </button>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              // CONTENIDO: CASO TURNO LIBRE (ASIGNAR O PROMOCIONAR)
              <>
                {/* Selector de Pestañas Premium */}
                <div className="px-5 pt-4">
                  <div className="grid grid-cols-2 bg-[#15171d] border border-[#2d313f] rounded-xl p-1 gap-1">
                    <button
                      type="button"
                      onClick={() => setModalActiveTab('assign')}
                      className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg text-xs font-black uppercase cursor-pointer transition-all duration-200 ${modalActiveTab === 'assign'
                          ? 'bg-[#222530] text-theme-primary shadow-md border border-theme-primary/30'
                          : 'text-zinc-500 hover:text-zinc-300'
                        }`}
                    >
                      <span>Asignar Turno</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => setModalActiveTab('promote')}
                      className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg text-xs font-black uppercase cursor-pointer transition-all duration-200 ${modalActiveTab === 'promote'
                          ? 'bg-purple-500/20 text-purple-400 border border-purple-500/40 shadow-md shadow-purple-500/5'
                          : 'text-zinc-500 hover:text-purple-300'
                        }`}
                    >
                      <span>🔥 Promocionar</span>
                    </button>
                  </div>
                </div>

                {modalActiveTab === 'assign' ? (
                  <div className="p-5 space-y-4 animate-in fade-in duration-200">

                    {/* 1. BUSCADOR DE JUGADORES (Habilitado si no hay jugador seleccionado) */}
                    {selectedPlayer ? (
                      <div className="space-y-1.5 animate-in fade-in zoom-in-95 duration-300">
                        <label className="block text-[10px] font-bold uppercase tracking-wider text-zinc-400">Jugador Seleccionado</label>
                        <div className="flex items-center justify-between bg-[#222530] border border-theme-primary/40 rounded-xl p-3 shadow-md">
                          <div className="flex items-center gap-2.5 min-w-0">
                            {selectedPlayer.photoUrl ? (
                              <img src={selectedPlayer.photoUrl} alt={selectedPlayer.name} className="w-8 h-8 rounded-full object-cover border border-[#2d313f] shrink-0" />
                            ) : (
                              <div className="w-8 h-8 rounded-full bg-[#1e202b] flex items-center justify-center border border-[#2d313f] shrink-0">
                                <User size={14} className="text-zinc-400" />
                              </div>
                            )}
                            <div className="min-w-0">
                              <h4 className="text-xs font-black text-white truncate leading-tight">{selectedPlayer.name}</h4>
                              <p className="text-[9px] text-theme-primary font-black uppercase mt-0.5 leading-none">{selectedPlayer.category || 'Cat No Definida'}</p>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedPlayer(null);
                              setSearchPlayerQuery('');
                            }}
                            className="p-1.5 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 hover:scale-110 active:scale-90 transition-all duration-200 shrink-0 cursor-pointer"
                            title="Deseleccionar jugador"
                          >
                            <X size={14} />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="space-y-1.5 relative">
                        <label className="flex items-center justify-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-zinc-400">
                          <Search size={12} className="text-[#FFE600]" />
                          Buscar Jugador Registrado
                        </label>
                        <input
                          type="text"
                          value={searchPlayerQuery}
                          onChange={(e) => {
                            setSearchPlayerQuery(e.target.value);
                            setShowPlayerDropdown(true);
                          }}
                          onFocus={() => setShowPlayerDropdown(true)}
                          placeholder="Escribe el nombre del jugador..."
                          className="w-full bg-[#15171d] border border-[#2d313f] rounded-xl px-3.5 py-2.5 text-xs text-white text-center focus:outline-none focus:border-theme-primary/60 transition-all placeholder:text-zinc-500 placeholder:opacity-50"
                        />

                        {/* Resultados de búsqueda */}
                        {filteredPlayers.length > 0 && showPlayerDropdown && (
                          <div className="absolute z-50 left-0 right-0 mt-1.5 bg-[#222530] border border-[#2d313f] rounded-xl max-h-40 overflow-y-auto overflow-x-hidden shadow-2xl custom-scrollbar">
                            {filteredPlayers.map((player) => (
                              <div
                                key={player.id}
                                onClick={() => {
                                  setSelectedPlayer(player);
                                  setSearchPlayerQuery(player.name);
                                  setShowPlayerDropdown(false);
                                }}
                                className="p-2.5 hover:bg-[#2d313f] hover:scale-[1.01] active:scale-[0.99] cursor-pointer transition-all duration-200 flex items-center gap-2.5 border-b border-[#2d313f]/55 last:border-b-0"
                              >
                                {player.photoUrl ? (
                                  <img src={player.photoUrl} alt={player.name} className="w-6 h-6 rounded-full object-cover shrink-0" />
                                ) : (
                                  <div className="w-6 h-6 rounded-full bg-[#1e202b] flex items-center justify-center border border-[#2d313f] shrink-0"><User size={10} className="text-zinc-400" /></div>
                                )}
                                <div>
                                  <p className="text-xs font-bold text-white leading-snug">{player.name}</p>
                                  <p className="text-[9px] text-theme-primary uppercase font-black leading-none mt-0.5">{player.category}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* 2. NOMBRE MANUAL (SI NO ESTÁ REGISTRADO) */}
                    {!selectedPlayer && (
                      <div className="space-y-3">
                        <div className="space-y-1.5">
                          <label className="flex items-center justify-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-zinc-400">
                            <User size={12} className="text-zinc-500" />
                            Registro Manual (No Registrado)
                          </label>
                          <input
                            type="text"
                            key={`name-${formResetKey}`}
                            defaultValue={manualPlayerName.current}
                            onChange={(e) => { manualPlayerName.current = e.target.value; }}
                            placeholder="Ej: Marcelo Gómez"
                            className="w-full bg-[#15171d] border border-[#2d313f] rounded-xl px-3.5 py-2.5 text-xs text-white text-center focus:outline-none focus:border-theme-primary/60 transition-all placeholder:text-zinc-500 placeholder:opacity-50"
                          />
                        </div>
                        <div className="space-y-1.5">
                          <label className="flex items-center justify-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-zinc-400">
                            <Phone size={12} className="text-zinc-500" />
                            Teléfono / WhatsApp (Opcional)
                          </label>
                          <input
                            type="tel"
                            key={`phone-${formResetKey}`}
                            defaultValue={manualPlayerPhone.current}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, '');
                              manualPlayerPhone.current = val;
                              e.target.value = val;
                            }}
                            placeholder="Ej: 1123456789"
                            className="w-full bg-[#15171d] border border-[#2d313f] rounded-xl px-3.5 py-2.5 text-xs text-white text-center focus:outline-none focus:border-theme-primary/60 transition-all placeholder:text-zinc-500 placeholder:opacity-50"
                          />
                        </div>
                      </div>
                    )}

                    {/* 4. CONFIGURACIÓN DE TURNO FIJO */}
                    <div className="space-y-1.5">
                      <label className="block text-center text-[10px] font-bold uppercase tracking-wider text-zinc-400">Tipo de turno</label>
                      <div className="relative">
                        <div className="grid grid-cols-2 bg-[#15171d] border border-[#2d313f] rounded-xl p-1 gap-1">
                          <button
                            type="button"
                            onClick={() => setManualIsFixed(false)}
                            className={`flex items-center justify-center gap-1.5 py-2 px-1 rounded-lg text-xs font-bold uppercase cursor-pointer transition-all duration-200 ${!manualIsFixed
                              ? 'bg-[#222530] text-theme-primary shadow-md border border-theme-primary/30'
                              : 'text-zinc-500 hover:text-zinc-300'
                              }`}
                          >
                            <span>Único</span>
                          </button>

                          <button
                            type="button"
                            onClick={() => setManualIsFixed(true)}
                            className={`flex items-center justify-center gap-1.5 py-2 px-1 rounded-lg text-xs font-bold uppercase cursor-pointer transition-all duration-200 ${manualIsFixed
                              ? 'bg-amber-500/20 text-amber-400 shadow-md border border-amber-500/50'
                              : 'text-zinc-500 hover:text-zinc-300'
                              }`}
                          >
                            <Pin size={13} className={`transition-all duration-300 ${manualIsFixed ? 'rotate-45 text-amber-400 scale-110' : 'text-zinc-500'}`} />
                            <span>Fijo</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* 5. NOTAS */}
                    <div className="space-y-1.5">
                      <label className="block text-center text-[10px] font-bold uppercase tracking-wider text-zinc-400">Notas / Comentarios</label>
                      <textarea
                        key={`notes-${formResetKey}`}
                        defaultValue={manualNotes.current}
                        onChange={(e) => { manualNotes.current = e.target.value; }}
                        placeholder="Detalles del turno (ej: Trae pelotas, paga seña, etc.)"
                        rows={2}
                        className="w-full bg-[#15171d] border border-[#2d313f] rounded-xl px-3.5 py-2.5 text-xs text-white text-center placeholder:text-zinc-500 placeholder:opacity-50 focus:outline-none focus:border-theme-primary/60 transition-all resize-none"
                      />
                    </div>

                    {/* BOTÓN ASIGNAR */}
                    <button
                      type="button"
                      onClick={handleAssignBooking}
                      className="w-full theme-primary-bg text-black font-black uppercase py-3.5 rounded-xl hover:scale-[1.02] active:scale-[0.98] hover:brightness-110 transition-all duration-200 text-xs tracking-wider shadow-lg shadow-theme-primary/15 mt-2 cursor-pointer"
                    >
                      Asignar Reserva
                    </button>
                  </div>
                ) : (
                  <div className="p-5 space-y-5 animate-in fade-in duration-200">
                    {/* 1. DESCUENTO */}
                    <div className="space-y-2">
                      <div className="flex items-center justify-between">
                        <label className="block text-[10px] font-black uppercase tracking-wider text-purple-400">
                          Porcentaje de Descuento
                        </label>
                        <span className="text-xs font-black text-green-400 bg-green-500/10 px-2 py-0.5 rounded border border-green-500/20">
                          {promoDiscount}% OFF
                        </span>
                      </div>
                      <div className="flex items-center gap-4 bg-[#15171d] border border-[#2d313f] p-3.5 rounded-xl">
                        <input
                          type="range"
                          min="0"
                          max="100"
                          step="5"
                          value={promoDiscount}
                          onChange={(e) => setPromoDiscount(Number(e.target.value))}
                          className="w-full h-1.5 bg-[#222530] rounded-lg appearance-none cursor-pointer accent-purple-500"
                        />
                      </div>
                      <p className="text-[9px] text-zinc-500 italic">
                        * Este descuento se aplicará sobre el precio base de la reserva para el jugador.
                      </p>
                    </div>

                    {/* 2. INCENTIVOS DE CORTESÍA (PERKS) */}
                    <div className="space-y-2">
                      <label className="block text-[10px] font-black uppercase tracking-wider text-purple-400">
                        Incentivos de Cortesía (Regalos)
                      </label>
                      <div className="grid grid-cols-1 gap-2">
                        {/* BEBIDA */}
                        <label className={`flex items-center justify-between p-3 rounded-xl border cursor-pointer select-none transition-all duration-200 ${promoDrink
                            ? 'bg-purple-500/10 border-purple-500/40 text-white font-bold'
                            : 'bg-[#15171d] border-[#2d313f] text-zinc-400 hover:border-zinc-700'
                          }`}>
                          <div className="flex items-center gap-3">
                            <span className="text-lg">🥤</span>
                            <div>
                              <p className="text-[11px] font-black uppercase tracking-wider">Bebida de cortesía</p>
                              <p className="text-[9px] text-zinc-500 font-medium">Bebida libre de regalo por jugador</p>
                            </div>
                          </div>
                          <input
                            type="checkbox"
                            checked={promoDrink}
                            onChange={(e) => setPromoDrink(e.target.checked)}
                            className="w-4 h-4 rounded text-purple-600 bg-zinc-900 border-[#2d313f] focus:ring-purple-500 focus:ring-offset-0 accent-purple-600 cursor-pointer"
                          />
                        </label>

                        {/* PELOTAS */}
                        <label className={`flex items-center justify-between p-3 rounded-xl border cursor-pointer select-none transition-all duration-200 ${promoBalls
                            ? 'bg-purple-500/10 border-purple-500/40 text-white font-bold'
                            : 'bg-[#15171d] border-[#2d313f] text-zinc-400 hover:border-zinc-700'
                          }`}>
                          <div className="flex items-center gap-3">
                            <span className="flex items-center justify-center w-6 h-6"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" className="drop-shadow-md"><circle cx="12" cy="12" r="10" fill="#ccff00" stroke="#9acd00" strokeWidth="1" /><path d="M6 5.3a9 9 0 0 1 0 13.4" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" /><path d="M18 5.3a9 9 0 0 0 0 13.4" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" /></svg></span>
                            <div>
                              <p className="text-[11px] font-black uppercase tracking-wider">Pelotas Nuevas</p>
                              <p className="text-[9px] text-zinc-500 font-medium">Tubo de pelotas nuevo para el partido</p>
                            </div>
                          </div>
                          <input
                            type="checkbox"
                            checked={promoBalls}
                            onChange={(e) => setPromoBalls(e.target.checked)}
                            className="w-4 h-4 rounded text-purple-600 bg-zinc-900 border-[#2d313f] focus:ring-purple-500 focus:ring-offset-0 accent-purple-600 cursor-pointer"
                          />
                        </label>

                        {/* PREMIO */}
                        <label className={`flex items-center justify-between p-3 rounded-xl border cursor-pointer select-none transition-all duration-200 ${promoWinnerPrize
                            ? 'bg-purple-500/10 border-purple-500/40 text-white font-bold'
                            : 'bg-[#15171d] border-[#2d313f] text-zinc-400 hover:border-zinc-700'
                          }`}>
                          <div className="flex items-center gap-3">
                            <span className="text-lg">🏆</span>
                            <div>
                              <p className="text-[11px] font-black uppercase tracking-wider">Premio al ganador</p>
                              <p className="text-[9px] text-zinc-500 font-medium">Premio especial para los ganadores</p>
                            </div>
                          </div>
                          <input
                            type="checkbox"
                            checked={promoWinnerPrize}
                            onChange={(e) => setPromoWinnerPrize(e.target.checked)}
                            className="w-4 h-4 rounded text-purple-600 bg-zinc-900 border-[#2d313f] focus:ring-purple-500 focus:ring-offset-0 accent-purple-600 cursor-pointer"
                          />
                        </label>
                      </div>
                    </div>

                    {/* BOTONES DE ACCIÓN */}
                    <div className="flex gap-3 pt-2">
                      {selectedSlot.booking?.status === 'promo' && (
                        <button
                          type="button"
                          onClick={handleDeletePromo}
                          className="flex-1 bg-red-500/10 hover:bg-red-500/20 text-red-400 border border-red-500/30 font-black uppercase py-3.5 rounded-xl hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 text-xs tracking-wider cursor-pointer"
                        >
                          Eliminar Promo
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={handleSavePromo}
                        className="flex-[2] bg-purple-500 hover:bg-purple-400 text-black font-black uppercase py-3.5 rounded-xl hover:scale-[1.02] active:scale-[0.98] hover:brightness-110 transition-all duration-200 text-xs tracking-wider shadow-lg shadow-purple-500/15 cursor-pointer"
                      >
                        {selectedSlot.booking?.status === 'promo' ? 'Actualizar Promo' : 'Publicar Promoción'}
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}

          </div>
        </div>,
        document.body
      )}
    </>
  );
};
